@import '~style-sheet-helpers/core.less';
@import '../../../app-brand/entities/entity-layer.module.less';

.label-header {
  display: block;
  margin-bottom: 4px;
  font-size: 14px;
  line-height: 18px;
  font-weight: @bold;
  margin-top: 12px;

  &.error {
    color: @settings-page--inventory-source--text-color;
  }
}

.inventory-dropdown {
  width: 300px;
}

.pill-bank {
  min-height: 120px;

  &.error {
    border: solid 1px @settings-page--inventory-source--border-color;
  }
}

.remove-all-button {
  margin-top: 4px;
  color: @settings-page--inventory-source--text-color;
}

.modal-body {
  padding: 16px 16px 32px;
  line-height: 20px;
}

.confirmation-list {
  list-style-type: disc;

  > li {
    margin-bottom: 10px;
  }
}

.checkbox {
  line-height: inherit;
}
